import { render, staticRenderFns } from "./Circle6.vue?vue&type=template&id=35f81a67&scoped=true&"
import script from "./Circle6.vue?vue&type=script&lang=js&"
export * from "./Circle6.vue?vue&type=script&lang=js&"
import style0 from "./Circle6.vue?vue&type=style&index=0&id=35f81a67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f81a67",
  null
  
)

export default component.exports